const selectLastSuccessfulWrite = (state: Record<string, any>): Date => {
  return state.lastSuccessfulWrite;
};

export default selectLastSuccessfulWrite;
